import { action, payload } from 'ts-action'
import { IExperience } from '@network/models/experience.model'
import { IError, IPayload } from '@network/models/global.model'

export const ExperiencesFetching = action(
  'ExperiencesFetching',
  payload<boolean>(),
)

export const GetExperiences = action(
  'GetExperiences',
  payload<IPayload<IExperience[]>>(),
)

export const GetExperiencesErrors = action(
  'GetExperiencesErrors',
  payload<IError>(),
)
